<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">交易机器人设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>Info</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <Creat></Creat>
        <!-- <el-select v-model="value" clearable placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-input
          placeholder="请输入交易对（fbsPair）"
          clearable
          v-model="fbsPair"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <InfoList :page="page" :size="size" :total="totalCount"></InfoList>
      <PageNation
        :total="totalCount"
        :size="size"
        :page="page"
        @pageChanged="handlePageChanged($event)"
      ></PageNation>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions,mapState } from "vuex";
import InfoList from "./components/Infolist";
import Creat from "./components/create";
import PageNation from "../../../components/pagination";

export default {
  data() {
    return {
      // totalCount:10,
      page: 1,
      size: 10,
      fbsPair: "",
     
    };
  },
  components: { InfoList, Creat, PageNation },
  computed: {
    ...mapState('robot',['totalCount'])
  },
  methods: {
    ...mapActions('robot',['getlist']),
    handleSearch() {
      this.getlist({pair:this.fbsPair,page:this.page,size:this.size})
    },
    handlePageChanged(e){
      this.page=e.page
      this.size=e.size
      this.getlist({...e,pair:this.fbsPair})
    }
  },
};
</script>

<style lang="less" scoped></style>
